<template lang="pug">
v-dialog(
  v-model="mode.reportDialog",
  persistent,
  scrollable,
  transition="dialog-left-transition",
  fullscreen
)
  v-card(ref="report")
    v-toolbar(color="primary", dense, dark)
      v-btn(@click.stop="vibrate(); close()", icon)
        v-icon mdi-close
      v-toolbar-title.ma-0 {{  formTitle(&apos;Report&apos;)  }}
      v-btn(@click.stop="vibrate(); download()", icon)
        v-icon mdi-download
      v-btn(@click.stop="vibrate(); printReport()", icon)
        v-icon mdi-printer
    v-card-text.pa-1
      small
        div
          v-row.box(ref="header", wrap, no-gutters)
            //
              <v-col cols="12">
              <v-row no-gutters>
            v-col(cols="3", sm="1") Restaurant:
            v-col(cols="9", sm="2") {{ getRestaurantHeader() }}
            v-col(
              cols="3",
              sm="1",
              v-if="['GA', 'RM'].includes(selectedUser.role)"
            ) Manager:
            v-col(cols="3", sm="1", v-if="['CC'].includes(selectedUser.role)") Counter Chef:
            v-col(cols="3", sm="1", v-if="['SS'].includes(selectedUser.role)") Section Supervisor:
            v-col(cols="9", sm="2") {{ editedItem.code }},{{ editedItem.inCharge }}
            v-col(cols="3", sm="1") Hours Open:
            v-col(cols="9", sm="2") {{ hours }}Hrs
            v-col(cols="3", sm="1") Opended At:
            v-col(cols="9", sm="2") {{ formatTS(editedItem.openTS) }}
            v-col(cols="3", sm="1") Closed At:
            v-col(cols="9", sm2) {{  editedItem.closedTS ? formatTS(editedItem.closedTS):&apos;Not closed&apos;  }}
            //
              </v-row>
              </v-col>
        v-row.pa-0.pl-1.pr-1(no-gutters)
          strong
            u Summary
            | :
          v-spacer
          span(@click="vibrate(); printSummary()")
            v-icon(color="indigo", small) mdi-printer
            strong Print
        div(
          v-if="allowed().includes('summary') && relevant().includes('summary')"
        )
          v-row(ref="summary", wrap, no-gutters)
            v-col(cols="12", sm="6")
              v-row.box.pa-0(no-gutters)
                v-col(xs="6", sm="4") Total Sales:
                v-col(xs="6", sm="8") {{ formatCurrency(summary.totalAmount) }}
                v-col(xs="6", sm="4") Total Tax:
                v-col(xs="6", sm="8") {{ formatCurrency(summary.totalTax || 0) }}
              v-row(no-gutters)
                v-col.box.pa-0(xs="12", sm="6")
                  pre.
                    {{summary.taxDetails.join('\n')}}                    
        div(
          v-if="allowed().includes('paymentsreceived') && relevant().includes('paymentsreceived')"
        )
          v-row.pa-0.pl-1.pr-1(no-gutters)
            strong Payments Received:
          v-row.box.pa-0(ref="paymentsreceived", wrap, no-gutters)
            template(v-for="payment in [...paymentsReceived]")
              v-col(xs="3", sm="1", :key="payment.type") {{ payment.type }}:
              v-col(xs="9", sm="2", :key="payment.amount + payment.type") {{ formatCurrency(payment.amount) }}
          v-row(ref="paymentsreceivedfooter", wrap, no-gutters)
            v-col(xs="3", sm="1")
              i Total
              | :
            v-col(xs="9", sm="2")
              | {{  formatCurrency(paymentsReceived.reduce((acc,p)=&gt;{return Number(acc)+Number(p.amount)},0))  }}
        div(v-if="myFeatures.eligibleFeatures.includes('REPORT')")
          div(
            v-if="allowed().includes('managerpayments') && relevant().includes('managerpayments')"
          )
            v-row.pa-0.pl-1.pr-1(no-gutters)
              strong Manager Payments:
            v-row.pa-0(ref="managerpayments", no-gutters)
              v-col(xs="12")
                v-row(no-gutters)
                  v-col(xs="6", sm="3", md="2", x="l1")
                    v-row.box.pa-0(no-gutters)
                      v-col(cols="3") {{ managerPayment.a }}:
                      v-col(cols="9") {{ managerPayment.n }}
                      v-col(cols="6") (@{{ managerPayment.r }}/Hr):
                      v-col(cols="6") {{ managerPayment.o }}Hrs
                      v-col(cols="6") Hourly :
                      v-col(cols="6") {{ formatCurrency(managerPayment.h) }}
                      v-col(cols="6") Commission:
                      v-col(cols="6") {{ formatCurrency(managerPayment.c) }}
                    hr
          div(
            v-if="allowed().includes('counterpayments') && relevant().includes('counterpayments')"
          )
            v-row.pa-0.pl-1.pr-1(no-gutters)
              strong Chef&apos;s Payments:
            v-row.pa-0(wrap, ref="chefspayments", no-gutters)
              v-col(xs="12")
                v-row(wrap, no-gutters)
                  v-col(
                    xs="6",
                    sm="3",
                    md="2",
                    x="l1",
                    v-for="cp in chefPayments",
                    :key="cp.a + cp.n"
                  )
                    v-row.box.pa-0(wrap, no-gutters)
                      v-col(cols="3") {{ cp.a }}:
                      v-col(cols="9") {{ cp.n }}
                      v-col(cols="6") (@{{ cp.r }}/Hr):
                      v-col(cols="6") {{ cp.o }}Hrs
                      v-col(cols="6") Hourly :
                      v-col(cols="6") {{ formatCurrency(cp.h) }}
                      v-col(cols="6") Commission:
                      v-col(cols="6") {{ formatCurrency(cp.c) }}
                    hr
            v-row.pa-0.pl-1.pr-1(ref="chefpaymentsfooter", wrap, no-gutters)
              v-col(xs="4", sm="2", md="1")
                i Hourly Total
                | :
              v-col(xs="2", sm="1", md="1")
                | {{  chefPayments.reduce &amp;&amp; formatCurrency(chefPayments.reduce((acc,p)=&gt;{return Number(acc)+Number(p.h)},0))  }}
              v-col(xs="4", sm="2", md="1")
                i Comm. Total
                | :
              v-col(xs="2", sm="1", md="1")
                | {{  chefPayments.reduce &amp;&amp; formatCurrency(chefPayments.reduce((acc,p)=&gt;{return Number(acc)+Number(p.c)},0))  }}
          div(
            v-if="allowed().includes('sectionpayments') && relevant().includes('sectionpayments')"
          )
            v-row.pa-0.pl-1.pr-1(no-gutters)
              strong Supervisors&apos; Payments:
            v-row.pa-0(ref="supervisorpayments", wrap, no-gutters)
              v-col(xs="12")
                v-row(wrap, no-gutters)
                  v-col(
                    xs="6",
                    sm="3",
                    md="2",
                    xl="1",
                    v-for="sp in supervisorPayments",
                    :key="sp.a + sp.n"
                  )
                    v-row.box.pa-0(xs="12", sm4, wrap, no-gutters)
                      v-col(cols="3") {{ sp.a }}:
                      v-col(cols="9") {{ sp.n }}
                      v-col(cols="6") (@{{ sp.r }}/Hr):
                      v-col(cols="6") {{ sp.o }}Hrs
                      v-col(cols="6") Hourly:
                      v-col(cols="6") {{ formatCurrency(sp.h) }}
                      v-col(cols="6") Commission:
                      v-col(cols="6") {{ formatCurrency(sp.c) }}
                    hr
            v-row.pa-0.pl-1.pr-1(
              ref="supervisorpaymentsfooter",
              wrap,
              no-gutters
            )
              v-col(xs="4", sm="2", md="1")
                i Hourly Total
                | :
              v-col(xs="2", sm="1", md="1")
                | {{  formatCurrency(supervisorPayments.reduce((acc,p)=&gt;{return Number(acc)+Number(p.h)},0))  }}
              v-col(xs="4", sm="2", md="1")
                i Comm. Total
                | :
              v-col(xs="2", sm="1", md="1")
                | {{  formatCurrency(supervisorPayments.reduce((acc,p)=&gt;{return Number(acc)+Number(p.c)},0))  }}
            v-row.pa-0.pl-1.pr-1(no-gutters)
              strong Waiters&apos; Payments:
            v-row.pa-0(ref="waiterpayments", wrap, no-gutters)
              v-col(xs="12")
                v-row(wrap, no-gutters)
                  v-col(
                    xs="6",
                    sm="3",
                    md="2",
                    xl="1",
                    v-for="sp in waiterPayments",
                    :key="sp.a + sp.n + sp.r"
                  )
                    v-row.box.pa-0(xs="12", sm="4", wrap, no-gutters)
                      v-col(cols="3") {{ sp.a }}:
                      v-col(cols="9") {{ sp.n }}
                      v-col(cols="6") (@{{ sp.r }}/Hr):
                      v-col(cols="6") {{ sp.o }}Hrs
                      v-col(cols="6") Hourly:
                      v-col(cols="6") {{ formatCurrency(sp.h) }}
                      v-col(cols="6") Commission:
                      v-col(cols="6") {{ formatCurrency(sp.c) }}
                    hr
            v-row.pa-0.pl-1.pr-1(ref="waiterpaymentsfooter", no-gutters, wrap)
              v-col(xs="4", sm="2", md="1")
                i Hourly Total
                | :
              v-col(xs="2", sm="1", md="1")
                | {{  formatCurrency(waiterPayments.reduce((acc,p)=&gt;{return Number(acc)+Number(p.h)},0))  }}
              v-col(xs="4", sm="2", md="1")
                i Comm. Total
                | :
              v-col(xs="2", sm="1", md="1")
                | {{  formatCurrency(waiterPayments.reduce((acc,p)=&gt;{return Number(acc)+Number(p.c)},0))  }}
            v-row.pa-0.pl-1.pr-1(no-gutters)
              strong Helpers&apos; Payments:
            v-row.pa-0.pl-1.pr-1(ref="helperpayments", wrap, no-gutters)
              v-col(xs="12")
                v-row(wrap, no-gutters)
                  v-col(
                    xs="6",
                    sm="3",
                    md="2",
                    xl="1",
                    v-for="sp in helperPayments",
                    :key="sp.a + sp.n + sp.r"
                  )
                    v-row.box.pa-0(xs="12", sm="4", wrap, no-gutters)
                      v-col(cols="3") {{ sp.a }}:
                      v-col(cols="9") {{ sp.n }}
                      v-col(cols="6") (@{{ sp.r }}/Hr):
                      v-col(cols="6") {{ sp.o }}Hrs
                      v-col(cols="6") Hourly:
                      v-col(cols="6") {{ formatCurrency(sp.h) }}
                      v-col(cols="6") Commission:
                      v-col(cols="6") {{ formatCurrency(sp.c) }}
                    hr
            v-row.pa-0.pl-1.pr-1(ref="helperpaymentsfooter", wrap, no-gutters)
              v-col(xs="4", sm="2", md="1")
                i Hourly Total
                | :
              v-col(xs="2", sm="1", md="1")
                | {{  formatCurrency(helperPayments.reduce((acc,p)=&gt;{return Number(acc)+Number(p.h)},0))  }}
              v-col(xs="4", sm="2", md="1")
                i Comm. Total
                | :
              v-col(xs="2", sm="1", md="1")
                | {{  formatCurrency(helperPayments.reduce((acc,p)=&gt;{return Number(acc)+Number(p.c)},0))  }}
        v-divider
        v-row.pa-0.pl-1.pr-1(no-gutters)
          strong
            u Details
            | :
        v-divider
        div(
          v-if="allowed().includes('products') && relevant().includes('products')"
        )
          v-row.pa-0.pl-1.pr-1(no-gutters)
            strong Products:
            v-spacer
            span(@click="vibrate(); printProducts()")
              v-icon(color="indigo", small) mdi-printer
              strong Print
          v-row.pa-0(ref="products", wrap, no-gutters)
            v-col(cols="12")
              v-row(wrap, no-gutters)
                v-col(
                  cols="6",
                  xs="6",
                  sm="2",
                  v-for="order in aggregateOrders",
                  :key="order.id"
                )
                  div(
                    v-if="applicableProducts.map((p) => p.id).includes(order._productKey)"
                  )
                    v-row.box.pa-0(wrap, no-gutters)
                      v-col(cols="3") {{ order.productCode }}:
                      v-col(cols="9") {{ order.productName }}
                      v-col(cols="6") Quantity:
                      v-col(cols="6") {{ order.quantity }}
                      template(v-if="relevant().includes('sectionpayments')")
                        v-col(cols="6") Rate:
                        v-col(cols="6") {{ formatCurrency(order.rate) }}
                        v-col(cols="6") Price:
                        v-col(cols="6") {{ formatCurrency(order.price) }}
                        v-col(cols="6") Tax Plan:
                        v-col(cols="6") {{ order.taxPlan }}
                        template(
                          v-if="myFeatures.eligibleFeatures.includes('REPORT')"
                        )
                          v-col(cols="6") Manager:
                          v-col(cols="6") {{ formatCurrency(order.managerFee) }}
                          v-col(cols="6") Supervisor:
                          v-col(cols="6") {{ formatCurrency(order.supervisorFee) }}
                          v-col(cols="6") Waiter:
                          v-col(cols="6") {{ formatCurrency(order.waiterFee) }}
                          v-col(cols="6") Helper:
                          v-col(cols="6") {{ formatCurrency(order.helperFee) }}
                      template(
                        v-if="myFeatures.eligibleFeatures.includes('REPORT')"
                      )
                        v-col(cols="6") Chef:
                        v-col(cols="6") {{ formatCurrency(order.chefFee) }}
        div(
          v-if="allowed().includes('services') && relevant().includes('services')"
        )
          v-row.pa-0.pl-1.pr-1(no-gutters)
            strong Services:
            v-spacer
            span(@click="vibrate(); printServices()")
              v-icon(color="indigo", small) mdi-printer
              strong Print
          v-row.pa-0.pl-1.pr-1(ref="services", wrap, no-gutters)
            v-col(cols="12")
              v-row(wrap, no-gutters)
                v-col(
                  cols="6",
                  sm="2",
                  v-for="service in [...services]",
                  :key="service.id"
                )
                  v-row.box.pa-0(wrap, no-gutters)
                    v-col(xs="12")
                      small
                        span(@click="vibrate(); print(service.billText)")
                          | {{ service.name }}
                          v-icon(color="indigo", small) mdi-printer
                          | Print
                        pre.
                          {{service.billText}}                          
                        u Payments:
                        br
                        template(v-if="service.payments")
                          pre(
                            v-for="(payment, idx) in [...service.payments]",
                            :key="payment.type + service.id + idx"
                          ).
                            {{`${payment.type}${payment.reference?'('+payment.reference+')':""}:`}}{{formatCurrency(payment.amount)}}                            
                          pre.
                            ================================                            
      v-divider
      v-row.pa-0.pl-1.pr-1(no-gutters)
        v-spacer
        v-btn(
          color="error",
          v-if="this.isCloseoutEnabled()",
          v-on:click.stop="executeCloseout()"
        ) Execute Closeout
        v-spacer
</template>

<script>
// import zlib from "zlib";
// import buffer from "buffer";
import moment from "moment";
import { storeMixin } from "../../mixins/storeMixin.js";
import { dialogsMixin } from "../../mixins/dialogsMixin.js";
import { taxPlans } from "../../config/taxPlans.js";
import { db, storage } from "../../config/db.js";
//import JP from "jsonpath";

export default {
  name: "report-dialog",
  mixins: [storeMixin, dialogsMixin],
  beforeMount() {
    if (this.editedItem.filePath) {
      const storageRef = storage.ref();
      const reportRef = storageRef.child(this.editedItem.filePath);
      reportRef.getDownloadURL().then((url) => {
        var xhr = new XMLHttpRequest();
        //xhr.responseType = "text/html";
        xhr.onload = (event) => {
          if (event) {
            Object.assign(this.editedItem, JSON.parse(xhr.response));
            this.loadApplicableOrders();
            this.loadApplicableServices();
          }
        };
        xhr.open("GET", url);
        xhr.send();
      });
    } else {
      if (
        !this.myFeatures.eligibleFeatures.includes("INVENTORY") &&
        this.groupProducts.length === 0
      ) {
        this.bindGroupProducts();
      }
      this.loadApplicableOrders();
      this.loadApplicableServices();
    }
  },
  data() {
    return {
      collectionName: "reports",
      dialogKey: "reportDialog",
      applicableOrders: [],
      applicableServices: [],
      distinctOrders: [], //orders grouped by product and sections
      aggregateOrders: [], //orders grouped by products only.
    };
  },
  computed: {
    applicableSections() {
      let applicableSections = this.editedItem.sections;
      if (!applicableSections) {
        applicableSections = [];
        if (this.editedItem.reportType === "restaurant") {
          applicableSections = this.mySections;
        } else {
          applicableSections = [this.selectedSection];
        }
      }
      return applicableSections;
    },
    applicableCounters() {
      let applicableCounters = this.editedItem.counters;
      if (!applicableCounters) {
        applicableCounters = [];
        if (this.editedItem.reportType === "restaurant") {
          applicableCounters = this.myCounters;
        } else {
          applicableCounters = [this.selectedCounter];
        }
      }
      return applicableCounters;
    },
    applicableProducts() {
      let applicableProducts = this.editedItem.products;
      if (!applicableProducts) {
        applicableProducts = [];
        if (this.editedItem.reportType === "restaurant") {
          applicableProducts = this.myProducts;
        } else {
          applicableProducts = this.myProducts.filter(
            (p) => p._counterKey === this.selectedCounter.id
          );
        }
      }
      return applicableProducts;
    },
    partners() {
      let partners = this.editedItem.partners;
      if (!partners) {
        partners = [];
        const manager = this.users.find(
          (u) => u.id === this.selectedRestaurant._managerId
        );
        partners.push(manager);
        const chefIds = this.applicableCounters.map((c) => c._chefId);
        const chefs = this.users.filter((u) => chefIds.includes(u.id));
        partners = [...partners, ...chefs];

        const svIds = this.applicableSections.map((c) => c._supervisorId);
        const supervisors = this.users.filter((u) => svIds.includes(u.id));
        partners = [...partners, ...supervisors];

        const helperIds = this.applicableSections.map((c) => c._helperId);
        const helpers = this.users.filter((u) => helperIds.includes(u.id));
        partners = [...partners, ...helpers];

        const waiterIds = this.applicableSections.map((c) => c._waiterId);
        const waiters = this.users.filter((u) => waiterIds.includes(u.id));
        partners = [...partners, ...waiters];
      }
      return partners;
    },
    services() {
      let services = this.editedItem.services;
      if (!services) {
        services = this.applicableServices;
      }
      return services;
    },
    paymentsReceived() {
      let paymentsReceived = this.editedItem.paymentsReceived;
      if (!paymentsReceived) {
        let payments = this.services.map((s) => s.payments);
        payments = payments.filter((p) => !!p).flat();
        paymentsReceived = payments.reduce((acc, p) => {
          if (p) {
            const found = acc.find((a) => a.type === p.type);
            if (found) {
              found.amount = Number(found.amount) + Number(p.amount);
              return acc;
            } else {
              return [...acc, Object.assign({}, p)];
            }
          }
        }, []);
      }
      return paymentsReceived;
    },
    summary() {
      let summary = this.editedItem.summary;
      if (!summary) {
        const maxCol = 31;
        let lines = [];
        let totalAmount = 0;
        let totalTax = 0;
        lines.push("Tax Details");
        const taxPlanAggregate = JSON.parse(JSON.stringify(taxPlans));
        this.distinctOrders.forEach((o) => {
          const taxPlan = taxPlanAggregate.find(
            (t) => t.code === (o.taxPlan || "IN-GST-A")
          );
          taxPlan.amount = Number(taxPlan.amount || 0) + Number(o.price);
        });
        taxPlanAggregate.forEach((p) => {
          if (p.amount) {
            lines.push(p.code + ":-");
            p.components.forEach((c) => {
              c.tax = (Number(p.amount || 0) * Number(c.rate)) / 100;
              lines.push(
                `${c.name}(${c.code})@${c.rate}%: ${
                  process.env.VUE_APP_CURRENCY
                }${parseFloat(c.tax).toFixed(2)}`.padStart(maxCol, " ")
              );
              totalTax += c.tax;
            });
            totalAmount += p.amount;
          }
        });
        summary = { totalTax, totalAmount, taxDetails: lines };
      }
      return summary;
    },
    managerPayment() {
      let managerPayment = this.editedItem.managerPayment;
      if (!managerPayment) {
        const manager = this.partners.find(
          (u) => u.id === this.selectedRestaurant._managerId
        );
        managerPayment = {
          a: this.selectedRestaurant.code,
          o: this.hours,
          n: manager.fullName,
          r: manager.hourlyRate,
          h: Number(manager.hourlyRate) * this.hours,
          c: this.distinctOrders.reduce(
            (a, o) => (a += Number(o.managerFee)),
            0
          ),
        };
      }
      return managerPayment;
    },
    chefPayments() {
      let chefPayments = this.editedItem.chefPayments;
      if (!chefPayments) {
        chefPayments = [];
        this.applicableCounters.forEach((c) => {
          const chef = this.partners.find((u) => u.id === c._chefId);
          const areaHours = this.getAreaHours(c.id);
          chefPayments.push({
            a: c.code,
            o: areaHours,
            n: chef.fullName,
            r: chef.hourlyRate,
            h: Number(chef.hourlyRate) * areaHours,
            c: this.distinctOrders
              .filter((o) => o._counterKey === c.id)
              .reduce((a, o) => (a += Number(o.chefFee)), 0),
          });
        });
      }
      return chefPayments;
    },
    supervisorPayments() {
      let supervisorPayments = this.editedItem.supervisorPayments;
      if (!supervisorPayments) {
        supervisorPayments = [];
        this.applicableSections.forEach((s) => {
          const supervisor = this.partners.find(
            (u) => u.id === s._supervisorId
          );
          const areaHours = this.getAreaHours(s.id);
          supervisorPayments.push({
            a: s.code,
            o: areaHours,
            n: supervisor.fullName,
            r: supervisor.hourlyRate,
            h: Number(supervisor.hourlyRate) * areaHours,
            c: this.distinctOrders
              .filter((o) => o._sectionKey === s.id)
              .reduce((a, o) => (a += Number(o.supervisorFee)), 0),
          });
        });
      }
      return supervisorPayments;
    },
    waiterPayments() {
      let waiterPayments = this.editedItem.waiterPayments;
      if (!waiterPayments) {
        waiterPayments = [];
        this.applicableSections.forEach((s) => {
          const waiter = this.partners.find((u) => u.id === s._waiterId);
          const areaHours = this.getAreaHours(s.id);
          waiterPayments.push({
            a: s.code,
            o: areaHours,
            n: waiter.fullName,
            r: waiter.hourlyRate,
            h: Number(waiter.hourlyRate) * areaHours,
            c: this.distinctOrders
              .filter((o) => o._sectionKey === s.id)
              .reduce((a, o) => (a += Number(o.waiterFee)), 0),
          });
        });
      }
      return waiterPayments;
    },
    helperPayments() {
      let helperPayments = this.editedItem.helperPayments;
      if (!helperPayments) {
        helperPayments = [];
        this.applicableSections.forEach((s) => {
          const helper = this.partners.find((u) => u.id === s._helperId);
          const areaHours = this.getAreaHours(s.id);
          helperPayments.push({
            a: s.code,
            o: areaHours,
            n: helper.fullName,
            r: helper.hourlyRate,
            h: Number(helper.hourlyRate) * areaHours,
            c: this.distinctOrders
              .filter((o) => o._sectionKey === s.id)
              .reduce((a, o) => (a += Number(o.helperFee)), 0),
          });
        });
      }
      return helperPayments;
    },
    hours() {
      let hours = this.editedItem.hours;
      if (!hours) {
        const minutes = parseInt(
          ((this.editedItem.closedTS || Date.now()) - this.editedItem.openTS) /
            60000
        );
        hours = parseFloat(minutes / 60).toFixed(2);
      }
      return hours;
    },
  },
  methods: {
    download() {
      this.applicableOrders.forEach((o) => {
        o.service = this.services.find((s) => s.id == o._serviceKey);
        o.group = this.selectedGroup;
        o.restaurant = this.selectedRestaurant;
        o.section = this.applicableSections.find((s) => s.id == o._sectionKey);
        o.counter = this.applicableCounters.find((c) => c.id == o._counterKey);
        o.product = this.applicableProducts.find((p) => p.id == o._productKey);
      });
      // eslint-disable-next-line no-console
      console.log(JSON.stringify(this.applicableOrders));
      alert("DOWNLOAD : TO BE DONE");
    },
    formTitle() {
      const word = this.editedItem.reportType;
      return `${word.charAt(0).toUpperCase() + word.slice(1)} Closeout Report`;
    },
    async loadApplicableServices() {
      if (this.editedItem.services) {
        this.applicableServices = this.editedItem.services;
      } else {
        const predicates = [
          { key: "_groupKey", op: "==", val: this.selectedGroup.id },
          { key: "_restaurantKey", op: "==", val: this.selectedRestaurant.id },
        ];
        if (this.editedItem.reportType === "restaurant") {
          const stf = {
            key: "status",
            op: "in",
            val: [this.STATUSES.PAID, this.STATUSES.CLOSED],
          };
          predicates.push(stf);
        } else if (this.editedItem.reportType === "section") {
          predicates.push({
            key: "_sectionKey",
            op: "==",
            val: this.selectedSection.id,
          });
          const stf = { key: "status", op: "==", val: this.STATUSES.PAID };
          predicates.push(stf);
        }
        this.applicableServices = await this.loadDocs({
          collectionName: "services",
          predicates: predicates,
        });
      }
    },
    async loadApplicableOrders() {
      if (this.editedItem.orders) {
        this.applicableOrders = this.editedItem.orders;
      } else {
        const predicates = [
          {
            key: "_groupKey",
            op: "==",
            val: this.selectedGroup.id,
          },
          {
            key: "_restaurantKey",
            op: "==",
            val: this.selectedRestaurant.id,
          },
          { key: "createdTS", op: ">", val: this.editedItem.openTS },
        ];
        if (this.editedItem.reportType === "restaurant") {
          // *** multiple inequality disallowed..but not required.
          // predicates.push({
          //   key: "status",
          //   op: ">=",
          //   val: this.STATUSES.CLEARED
          // });
        } else if (this.editedItem.reportType === "section") {
          predicates.push({
            key: "_sectionKey",
            op: "==",
            val: this.selectedSection.id,
          });
          predicates.push({
            key: "status",
            op: "in",
            val: [this.STATUSES.PAIDINSERVICE, this.STATUSES.CLOSEDINCOUNTER],
          });
        } else if (this.editedItem.reportType === "counter") {
          predicates.push({
            key: "_counterKey",
            op: "==",
            val: this.selectedCounter.id,
          });
          predicates.push({
            key: "status",
            op: "in",
            val: [this.STATUSES.PAIDINSERVICE, this.STATUSES.CLOSEDINSECTION],
          });
        }
        this.applicableOrders = await this.loadDocs({
          collectionName: "orders",
          predicates: predicates,
        });
        if (this.myFeatures.eligibleFeatures.includes("WORKFLOW")) {
          this.applicableOrders.forEach((o) => {
            const prod = this.restaurantProducts.find(
              (p) => o._productKey === p.id
            );
            const user = this.selectedUser;
            if (["GA", "RM"].includes(user.role)) {
              o.managerFee = Number(prod.managerFee);
            }
            if (["GA", "RM", "CC"].includes(user.role)) {
              o.chefFee = Number(prod.chefFee);
            }
            if (["GA", "RM", "SS"].includes(user.role)) {
              o.supervisorFee = Number(prod.supervisorFee);
              o.waiterFee = Number(prod.waiterFee);
              o.helperFee = Number(prod.helperFee);
            }
          });
        }
      }
      this.setDistinctOrders();
      this.setAggregateOrders();
    },
    setDistinctOrders() {
      this.distinctOrders = this.applicableOrders.reduce((acc, o) => {
        const found = acc.find(
          (a) =>
            a._productKey === o._productKey && a._sectionKey === o._sectionKey
        );
        if (found) {
          found.quantity = Number(found.quantity) + Number(o.quantity);
          return acc;
        } else {
          return [...acc, Object.assign({}, o)];
        }
      }, []);
      this.distinctOrders.forEach((o) => {
        o.price = Number(o.rate) * Number(o.quantity);
        o.managerFee &&
          (o.managerFee = Number(o.managerFee) * Number(o.quantity));
        o.chefFee && (o.chefFee = Number(o.chefFee) * Number(o.quantity));
        o.supervisorFee &&
          (o.supervisorFee = Number(o.supervisorFee) * Number(o.quantity));
        o.waiterFee && (o.waiterFee = Number(o.waiterFee) * Number(o.quantity));
        o.helperFee && (o.helperFee = Number(o.helperFee) * Number(o.quantity));
      });
    },
    setAggregateOrders() {
      this.aggregateOrders = this.applicableOrders.reduce((acc, o) => {
        const found = acc.find((a) => a._productKey === o._productKey);
        if (found) {
          found.quantity = Number(found.quantity) + Number(o.quantity);
          return acc;
        } else {
          return [...acc, Object.assign({}, o)];
        }
      }, []);
      this.aggregateOrders.forEach((o) => {
        o.price = Number(o.rate) * Number(o.quantity);
        o.managerFee &&
          (o.managerFee = Number(o.managerFee) * Number(o.quantity));
        o.chefFee && (o.chefFee = Number(o.chefFee) * Number(o.quantity));
        o.supervisorFee &&
          (o.supervisorFee = Number(o.supervisorFee) * Number(o.quantity));
        o.waiterFee && (o.waiterFee = Number(o.waiterFee) * Number(o.quantity));
        o.helperFee && (o.helperFee = Number(o.helperFee) * Number(o.quantity));
      });
    },
    allowed() {
      const role = this.selectedUser.role;
      let allowed = [];
      switch (role) {
        case "GA":
        case "RM":
          allowed = [
            "summary",
            "paymentsreceived",
            "managerpayments",
            "sectionpayments",
            "counterpayments",
            "products",
            "services",
          ];
          break;
        case "SS":
          allowed = ["sectionpayments", "services"];
          break;
        case "CC":
          allowed = ["counterpayments", "products"];
          break;
        default:
          allowed = [];
      }
      return allowed;
    },
    relevant() {
      const reportType = this.editedItem.reportType;
      let relevant = [];
      switch (reportType) {
        case "restaurant":
          relevant = [
            "summary",
            "paymentsreceived",
            "managerpayments",
            "sectionpayments",
            "counterpayments",
            "products",
            "services",
          ];
          break;
        case "section":
          relevant = ["paymentsreceived", "sectionpayments", "services"];
          break;
        case "counter":
          relevant = ["counterpayments", "products"];
          break;
        default:
          relevant = [];
      }
      return relevant;
    },
    getRestaurantHeader() {
      const restaurant = this.selectedRestaurant;
      return `${restaurant.code},${restaurant.name},${restaurant.addressLine2}`;
    },
    getAreaHours(areaId) {
      if (this.editedItem.reportType === "restaurant") {
        let areaMinutes = 0;
        const sectionReport = this.sectionReport(areaId);
        const counterReport = this.counterReport(areaId);
        let areaReports = this.editedItem.areaReports || [];
        if (sectionReport) areaReports = [...areaReports, sectionReport];
        if (counterReport) areaReports = [...areaReports, counterReport];
        areaReports
          .filter((a) => {
            return (
              (a._sectionKey ? a._sectionKey === areaId : false) ||
              (a._counterKey ? a._counterKey === areaId : false)
            );
          })
          .forEach((a) => {
            const minutes = parseInt(
              ((a.closedTS || Date.now()) - a.openTS) / 60000
            );
            areaMinutes += minutes;
          });
        return parseFloat(areaMinutes / 60).toFixed(2);
      } else {
        return this.hours;
      }
    },
    log() {
      //console.log(this.$refs.report);
    },
    executeCloseout() {
      const report = this.editedItem;
      report.closedTS = Date.now();
      report.status = this.STATUSES.CLOSEDOUT;
      this.slurpReportContent();
      const restaurant = this.selectedRestaurant;
      const storageRef = storage.ref();
      const reportRef = storageRef.child(this.getStoragePath());
      //let compressed = zlib.deflate(new buffer.Buffer(JSON.stringify(report)));
      const compressed = JSON.stringify(report);
      if (report.reportType === "restaurant") {
        // report.services = this.closedRestaurantServices;
        // report.paymentsReceived = this.paymentsReceived;
        //upload stringified report to storage

        reportRef.putString(compressed).then((snapshot) => {
          //update report metadata by stripping off the content part
          report.filePath = snapshot.metadata.fullPath;
          this.clearReportContent();
          this.updateDoc({
            collectionName: "reports",
            docId: report.id,
            doc: report,
          });
          //Close the restaurant
          restaurant.status = this.STATUSES.CLOSEDOUT;
          this.updateFields({
            collectionName: "restaurants",
            docId: restaurant.id,
            subDoc: { status: restaurant.status },
          });
          //Clean(delete) all restaurant orders
          this.applicableOrders.forEach((o) => {
            this.deleteDoc({ collectionName: "orders", docId: o.id });
          });
          //Clean(delete) all restaurant services
          this.applicableServices.forEach((s) => {
            this.deleteDoc({ collectionName: "services", docId: s.id });
          });
          //applicable only of No REPORT feature
          if (!this.myFeatures.eligibleFeatures.includes("REPORT")) {
            //Free version
            //close the section and counter
            this.sections.forEach((s) => {
              s.status = this.STATUSES.CLOSEDOUT;
              this.updateFields({
                collectionName: "sections",
                docId: s.id,
                subDoc: { status: s.status },
              });
            });
            this.counters.forEach((c) => {
              c.status = this.STATUSES.CLOSEDOUT;
              this.updateFields({
                collectionName: "counters",
                docId: c.id,
                subDoc: { status: c.status },
              });
            });
          }
          this.close();
        });
      } else if (report.reportType === "counter") {
        const counter = this.selectedCounter;
        //upload stringified report
        reportRef.putString(compressed).then((snapshot) => {
          //update report metadata by stripping off the content part
          report.filePath = snapshot.metadata.fullPath;
          this.clearReportContent();
          this.updateDoc({
            collectionName: "reports",
            docId: report.id,
            doc: report,
          });
          //Close the counter
          counter.status = this.STATUSES.CLOSEDOUT;
          this.updateFields({
            collectionName: "counters",
            docId: counter.id,
            subDoc: { status: counter.status },
          });
          //close all orders
          this.applicableOrders.forEach((o) => {
            o.status = this.STATUSES.CLOSEDINCOUNTER;
            this.updateFields({
              collectionName: "orders",
              docId: o.id,
              subDoc: { status: o.status },
            });
          });
          //push this child report metadata to parent report(restaurant report)
          if (this.restaurantReport.areaReports) {
            this.restaurantReport.areaReports.push(report);
          } else {
            this.restaurantReport.areaReports = [report];
          }
          this.updateFields({
            collectionName: "reports",
            docId: this.restaurantReport.id,
            subDoc: { areaReports: this.restaurantReport.areaReports },
          });
          this.close();
        });
      } else if (report.reportType === "section") {
        // report.services = this.services;
        const section = this.selectedSection;
        //upload stringified report
        reportRef.putString(compressed).then((snapshot) => {
          //update report metadata by stripping off the content part
          report.filePath = snapshot.metadata.fullPath;
          this.clearReportContent();
          this.updateDoc({
            collectionName: "reports",
            docId: report.id,
            doc: report,
          });
          //close the serction
          section.status = this.STATUSES.CLOSEDOUT;
          this.updateFields({
            collectionName: "sections",
            docId: section.id,
            subDoc: { status: section.status },
          });
          //Close all services
          this.applicableServices.forEach((s) => {
            s.status = this.STATUSES.CLOSED;
            this.updateFields({
              collectionName: "services",
              docId: s.id,
              subDoc: { status: s.status },
            });
          });
          //close all orders
          this.applicableOrders.forEach((o) => {
            o.status = this.STATUSES.CLOSEDINSECTION;
            this.updateFields({
              collectionName: "orders",
              docId: o.id,
              subDoc: { status: o.status },
            });
          });
          //push this child report metadata to parent report(restaurant report)
          if (this.restaurantReport.areaReports) {
            this.restaurantReport.areaReports.push(report);
          } else {
            this.restaurantReport.areaReports = [report];
          }
          this.updateFields({
            collectionName: "reports",
            docId: this.restaurantReport.id,
            subDoc: { areaReports: this.restaurantReport.areaReports },
          });
        });
        this.close();
      }
    },
    slurpReportContent() {
      const report = this.editedItem;
      report.sections = this.applicableSections;
      report.counters = this.applicableCounters;
      report.orders = this.applicableOrders;
      report.products = this.applicableProducts;

      report.partners = this.partners;
      if (report.reportType === "restaurant") {
        report.summary = this.summary;
        if (this.myFeatures.eligibleFeatures.includes("REPORT")) {
          report.managerPayment = this.managerPayment;
        }
        report.services = this.applicableServices;
        report.paymentsReceived = this.paymentsReceived;
      }
      if (report.reportType === "section") {
        report.services = this.services;
        report.supervisorPayments = this.supervisorPayments;
        report.waiterPayments = this.waiterPayments;
        report.helperPayments = this.helperPayments;
      }
      if (report.reportType === "counter") {
        report.chefPayments = this.chefPayments;
      }
    },
    clearReportContent() {
      const report = this.editedItem;
      report.sections = "";
      report.counters = "";
      report.orders = "";
      report.products = "";
      report.partners = "";
      if (report.reportType === "restaurant") {
        report.summary = "";
        report.managerPayment = "";
        report.services = "";
        report.paymentsReceived = "";
      }
      if (report.reportType === "section") {
        report.services = "";
        report.supervisorPayments = "";
        report.waiterPayments = "";
        report.helperPayments = "";
      }
      if (report.reportType === "counter") {
        report.chefPayments = ";";
      }
    },
    getStoragePath() {
      const report = this.editedItem;
      let storagePath = `reports/groups/${report._groupKey}/restaurants/${report._restaurantKey}/`;
      switch (report.reportType) {
        case "section":
          storagePath += `sections/${report._sectionKey}/${report.id}.json`;
          break;
        case "counter":
          storagePath += `counters/${report._counterKey}/${report.id}.json`;
          break;
        default:
          storagePath += `${report.id}.json`;
          break;
      }
      return storagePath;
    },
    printSummary() {
      const printLayout = [
        { title: this.formTitle(), ref: "header" },
        { title: "Summary", ref: "summary" },
        { title: "Payments Received", ref: "paymentsreceived" },
        { title: "", ref: "paymentsreceivedfooter" },
        { title: "Manager Payments", ref: "managerpayments" },
        { title: "Chefs Payments", ref: "chefspayments" },
        { title: "", ref: "chefpaymentsfooter" },
        { title: "Supervisor Payments", ref: "supervisorpayments" },
        { title: "", ref: "supervisorpaymentsfooter" },
        { title: "Waiters Payments", ref: "waiterpayments" },
        { title: "", ref: "waiterpaymentsfooter" },
        { title: "Helpers Payments", ref: "helperpayments" },
        { title: "", ref: "helperpaymentsfooter" },
      ];
      const printText = this.formatPrintText(printLayout);
      this.print(printText);
    },
    printProducts() {
      const printLayout = [
        { title: "Closeout Products Details", ref: "header" },
        { title: "", ref: "products" },
      ];
      const printText = this.formatPrintText(printLayout);
      this.print(printText);
    },
    printServices() {
      const printLayout = [
        { title: "Closeout Services Details", ref: "header" },
      ];
      const header = this.formatPrintText(printLayout);
      this.print(
        `${header}\n${this.$refs.services && this.$refs.services.innerText}`
      );
    },
    formatPrintText(printLayout) {
      const maxCol = 32;
      let printText = "";
      printLayout.forEach((p) => {
        const kvps =
          this.$refs[p.ref] &&
          this.$refs[p.ref].innerText.replace(/:\n/g, ":").split("\n");
        if (kvps) {
          if (p.title) {
            printText += "\n--------------------------------\n";
            printText += p.title.padStart((maxCol + p.title.length) / 2, " ");
            printText += "\n--------------------------------";
          }
          kvps.forEach((kvp) => {
            const splitKvp = kvp.split(":");
            let [k, v] = [splitKvp[0], splitKvp.slice(1).join(":")];
            v = v && v.trim();
            printText +=
              "\n" + k.padEnd(maxCol - (v && v.length) - 2, " ") + ": " + v;
          });
          printText += "\n================================";
        }
      });
      return printText;
    },
    printReport() {
      const printContents = this.$refs.report.$el.innerHTML;
      const headContents = window.document.getElementsByTagName("head")[0]
        .innerHTML;
      const pwin = window.open();
      pwin.document.write(
        `<html><head>${headContents}</head><body>${printContents}</body></html>`
      );
      setTimeout(() => {
        pwin.print();
        pwin.close();
      }, 1000);
    },
    formatCurrency(amount) {
      return process.env.VUE_APP_CURRENCY + parseFloat(amount).toFixed(2);
    },
    formatTS(ts) {
      return moment(Number(ts)).format("DD-MMM-YYYY LT");
    },
    isCloseoutEnabled() {
      return ["restaurantReport", "sectionReport", "counterReport"].includes(
        this.$route.name
      );
    },
    close() {
      if (this.isCloseoutEnabled()) {
        this.$router.push("/home");
      } else {
        this.cancel(this.dialogKey);
      }
    },
    async loadDocs({ collectionName, predicates }) {
      let query = db.collection(collectionName);
      if (predicates && predicates.length) {
        predicates.forEach((p) => {
          query = query.where(p.key, p.op, p.val);
        });
      }
      const resultSet = await query.get();
      const docs = [];
      resultSet.forEach((doc) => {
        const d = Object.assign({}, doc.data());
        d.id = doc.id;
        docs.push(d);
      });
      return docs;
    },
  },
};
</script>
<style >
.box {
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
}
.repitem {
  height: 20px;
}
</style>